<template>
    <div class="home">
        <section class="welcome-section">
            <div class="hero-copy">
                <h1 v-html="title"></h1>
                <p v-html="intro"></p>
            </div>

            <div v-if="homepageCategories.length" class="category-grid" aria-label="Produktkategorien">
                <button
                    v-for="(category, index) in homepageCategories"
                    :key="category.id || category.name || index"
                    type="button"
                    class="category-pill"
                    :style="{ color: category.textColor || '#1f1f1f' }"
                    @click="goToCategory(category)"
                >
                    <img
                        v-if="category.image"
                        :src="category.image"
                        :alt="category.name || 'Kategorie'"
                        class="category-image"
                    />
                    <span class="category-name">{{ category.name }}</span>
                </button>
            </div>

            <img v-if="heroUrl" :src="heroUrl" alt="Hero" style="width:100%; margin-top:12px; border-radius:6px;" />
        </section>

        <section v-if="homepageCombinedContent" class="section" v-html="homepageCombinedContent"></section>

        <template v-else>
            <!-- About us -->
            <section class="section">
                <h2>{{ whoWeAreTitle }}</h2>
                <p>{{ whoWeAreText }}</p>
            </section>

            <!-- What we do -->
            <section class="section">
                <h2>{{ whatWeDoTitle }}</h2>
                <p>{{ whatWeDoText }}</p>
            </section>
        </template>

    </div>
</template>

<script>
import { useConfig } from '../composables/useConfig.js';

export default {
    name: "HomePage",
    setup() {
        const { config, loadConfig, applyColors } = useConfig();
        loadConfig().then(() => applyColors());
        return { config };
    },
    data() {
        return {
            heroUrl: null
        };
    },
    methods: {
        slugify(value) {
            return String(value || '')
                .toLowerCase()
                .trim()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-z0-9]+/g, '-')
                .replace(/^-+|-+$/g, '') || 'kategorie';
        },
        goToCategory(category) {
            const slug = this.slugify(category?.name || 'kategorie');
            const params = { slug };
            const query = {};

            if (category && category.tagId !== undefined && category.tagId !== null && category.tagId !== '') {
                query.tagId = String(category.tagId);
            }

            this.$router.push({ name: 'ProductCategoryPage', params, query });
        }
    },
    computed: {
        title() {
            return this.config?.homepage?.heroSection_title || 'Die kleine Dekoecke';
        },
        intro() {
            return this.config?.homepage?.heroSection_intro || 'Handgegossene Dekoration aus Raysin...';
        },
        homepageCategories() {
            const categories = this.config?.homepage?.categories;
            if (!Array.isArray(categories)) return [];
            return categories.filter(category => category && (category.name || category.image));
        },
        homepageCombinedContent() {
            return this.config?.homepage?.combinedContent || '';
        },
        whoWeAreTitle() {
            return this.config?.homepage?.whoWeAreSection_title || 'Wer wir sind';
        },
        whoWeAreText() {
            return this.config?.homepage?.whoWeAreSection_text || '';
        },
        whatWeDoTitle() {
            return this.config?.homepage?.whatWeDoSection_title || 'Was wir machen';
        },
        whatWeDoText() {
            return this.config?.homepage?.whatWeDoSection_text || '';
        }
    }
};
</script>

<style scoped>
.home {
    max-width: 900px;
    margin: 0 auto;
    padding: 1.5rem;
}

.welcome-section {
    background: transparent;
    color: var(--body-text-color, #333);
    padding: 0;
    margin-bottom: 2rem;
}

.hero-copy {
    max-width: 760px;
    margin: 0 auto 1.2rem;
}

.welcome-section h1 {
    margin-bottom: 0.75rem;
    color: var(--theme-primary-color, #2d1b14);
    font-size: clamp(2rem, 4vw, 3rem);
    line-height: 1.2;
}

.welcome-section p {
    margin: 0;
    max-width: 760px;
    font-size: 1.05rem;
    line-height: 1.6;
}

.category-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    margin: 1.2rem 0 1.5rem;
}

.category-pill {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 180px;
    height: 120px;
    border-radius: 50% / 45%;
    overflow: hidden;
    border: 2px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    background: #f3f3f3;
    cursor: pointer;
    padding: 0;
}

.category-image {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.category-name {
    position: relative;
    z-index: 1;
    display: block;
    width: 100%;
    padding: 0 0.5rem;
    text-align: center;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1.2;
    text-shadow: 0 2px 8px rgba(255, 255, 255, 0.8);
}

.section {
    margin-bottom: 1.5rem;
}

.section h2 {
    margin-bottom: 0.5rem;
}
</style>